import debounce from 'lodash-es/debounce';

/**
 * Метод получения длинны скролла
 * @return {number} - длинна скролла
 */
const getScrollBarWidth = () => {
	const outer = document.createElement('div');
	outer.style.visibility = 'hidden';
	outer.style.overflow = 'scroll';
	outer.style.msOverflowStyle = 'scrollbar';
	document.body.appendChild(outer);
	const inner = document.createElement('div');
	outer.appendChild(inner);
	const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
	outer.parentNode.removeChild(outer);
	return scrollbarWidth;
};

// Обновление длины скролла
window.addEventListener('resize', debounce(() => {
	document.documentElement.style.setProperty('--scroll-bar-width', getScrollBarWidth() + 'px');
}, 500));

// Установка длины скролла
document.addEventListener('DOMContentLoaded', () => {
	document.documentElement.style.setProperty('--scroll-bar-width', getScrollBarWidth() + 'px');
});

export { getScrollBarWidth };

